// Define the unique unique_url values for organization and site.
// If both are present, the base path is used as root (/) (e.g., engbers-bau.de).
// If one is missing, the additional path is used. (e.g., engbers-bau/karriere)

// ========= LOCAL TEST CONFIGURATION =========
// These settings only apply to local development environment
// Set the module to be tested for direct paths (e.g., /engbers-bau/formular-unique-url)
const DEV_CONFIG = {
  // Which module should be used for direct paths 
  // Possible modules: 'forms', 'jobOffers', 'feedback', ...
  // Set to null to disable
  pathModuleType: null  // null or one of the module names
};
// ========= END TEST CONFIGURATION =========

// Mapping module subdomains to API mappings
const moduleSubdomains = {
    "forms": { 
        module: "formulare", 
        moduleId: 9010,
        hasListView: true
    },
    "links": {
        module: "links", 
        moduleId: 1325,
        hasListView: false
    },
    "jobOffers": { 
        module: "stellen", 
        moduleId: 2610,
        hasListView: true
    },
    "events": { 
        module: "veranstaltungen", 
        moduleId: 1610,
        hasListView: true
    },
    "feedback": {
        module: "feedback",
        moduleId: 4650, // This ID must match the one in dynamicModules.js!
        hasListView: false,
        isStaticPage: true // This is crucial for correct rendering
    },
    "checkout": {
        module: "checkout",
        moduleId: 9999,
        hasListView: false,
        isStaticPage: true
    },
    "impressum": {
        module: "impressum",
        moduleId: 1380,
        hasListView: false,
        isStaticPage: true
    },
    "datenschutz": {
        module: "datenschutz",
        moduleId: 1390,
        hasListView: false,
        isStaticPage: true
    }
    
    // Add more modules here
};

let organizationUniqueUrl = null;
let siteUniqueUrl = null;
let apiSystem = null;
let apiEnv = null;
let moduleType = null;
let pathModuleType = null;

switch(window.location.hostname) {
    case 'localhost':
    case '127.0.0.1':
        // Local development environment with test configuration
        apiSystem = "canou";
        apiEnv = "dev";

        // organizationUniqueUrl = "onlinemarketing-de";
        // siteUniqueUrl = "ey";
        
        // Activate the module configured in DEV_CONFIG for direct paths
        if (DEV_CONFIG.pathModuleType && moduleSubdomains[DEV_CONFIG.pathModuleType]) {
            pathModuleType = moduleSubdomains[DEV_CONFIG.pathModuleType];
            console.log(`[DEV] Module activated for direct paths: ${DEV_CONFIG.pathModuleType}`);
        }
        break;

    case 'juedisches-leben-weener.de':
        organizationUniqueUrl = "museeum-weener";
        siteUniqueUrl = "juedisches-leben";
        apiSystem = "canou";
        apiEnv = "live";
        break;

    case 'www.juedisches-leben-weener.de':
        organizationUniqueUrl = "museeum-weener";
        siteUniqueUrl = "juedisches-leben";
        apiSystem = "canou";
        apiEnv = "live";
        break;

    case 'cdn.kroegeritcdn.de':
        apiSystem = "canou";
        apiEnv = "live";
        break;

    case 'karriere.engbers-bau.de':
        organizationUniqueUrl = "engbers-bau";
        siteUniqueUrl = "karriere";
        apiSystem = "canou";
        apiEnv = "live";
        break;

    case "ey.digitalbash.de":
        organizationUniqueUrl = "onlinemarketing-de";
        siteUniqueUrl = "ey";
        apiSystem = "digitalbash";
        apiEnv = "live";
        break;

    case "website.canou.io":
        apiSystem = "canou";
        apiEnv = "live";
        break;
        
    case "website-beta.canou.io":
        apiSystem = "canou";
        apiEnv = "dev";
        break;

    // Module pages via subdomains
    case "forms.canou.io":
        moduleType = moduleSubdomains["forms"];
        apiSystem = "canou";
        apiEnv = "live";
        break;
    
    case "links.canou.io":
        moduleType = moduleSubdomains["links"];
        apiSystem = "canou";
        apiEnv = "live";
        break;
    
    case "jobs.canou.io":
        moduleType = moduleSubdomains["jobOffers"];
        apiSystem = "canou";
        apiEnv = "live";
        break;
    
    case "events.canou.io":
        moduleType = moduleSubdomains["events"];
        apiSystem = "canou";
        apiEnv = "live";
        break;

    case "feedback.canou.io":
        moduleType = moduleSubdomains["feedback"];
        apiSystem = "canou";
        apiEnv = "live";
        break;

    case "checkout.canou.io":
        moduleType = moduleSubdomains["checkout"];
        apiSystem = "canou";
        apiEnv = "live";
        break;

    case "impressum.canou.io":
        moduleType = moduleSubdomains["impressum"];
        apiSystem = "canou";
        apiEnv = "live";
        break;

    case "datenschutz.canou.io":
        moduleType = moduleSubdomains["datenschutz"];
        apiSystem = "canou";
        apiEnv = "live";
        break;

    default:
        apiSystem = "canou";
        apiEnv = "dev";
}

export { organizationUniqueUrl, siteUniqueUrl, apiSystem, apiEnv, moduleType, pathModuleType };